var _path, _circle, _path2, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApLoiSharedBlackIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.61 10.9731C10.61 9.56612 10.0511 8.21677 9.05623 7.22189C8.06135 6.227 6.712 6.4314 5.30502 6.4314C3.89804 6.4314 2.54869 6.227 1.5538 7.22189C0.55892 8.21677 2.12448e-07 9.56612 0 10.9731L5.30502 10.9731H10.61Z",
    fill: "#404040"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.30581,
    cy: 2.86246,
    r: 2.86246,
    fill: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2194 16.6997C21.2194 15.2927 20.6605 13.9433 19.6656 12.9484C18.6707 11.9536 17.3214 12.158 15.9144 12.158C14.5074 12.158 13.1581 11.9536 12.1632 12.9484C11.1683 13.9433 10.6094 15.2927 10.6094 16.6997L15.9144 16.6997H21.2194Z",
    fill: "#404040"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9152,
    cy: 8.58902,
    r: 2.86246,
    fill: "#404040"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApLoiSharedBlackIcon);
export default __webpack_public_path__ + "static/media/ap_loi_shared_black_icon.501dbc96e8ab414ee63395f58ed2b3e4.svg";
export { ForwardRef as ReactComponent };